import React, { useCallback } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { useUser } from 'providers/UserProvider'

import { FunnelSimple } from 'phosphor-react'
import { Row, Column } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'
import { NextImage } from 'components/v2/NextImage'
import { Button } from 'components/v2/Button'
import { RangeSlider } from 'components/v2/RangeSlider'
import TypeaheadSelect from 'components/v2/MoreFilters/TypeheadSelect'

import { collapse, updateFilter } from 'redux/modules/filters'

import 'react-dates/initialize'

const TopFilters = ({ onSearchPsychologists = () => {} }) => {
  const dispatch = useDispatch()
  const { shouldHideConsultationValue } = useUser()
  const { filters, psychologists } = useSelector(state => ({
    filters: state.filters,
    psychologists: state.psychologists
  }))

  const onChangeConsultationPriceRange = ([min_price, max_price]) =>
    dispatch(updateFilter({ min_price, max_price }))

  const onToggleMoreFiltersVisibility = () => dispatch(collapse())

  return (
    <Column>
      <Container>
        <Row width='100%' flexDirection={['column', 'row']} gridColumnGap='24px'>
          <TypeaheadSelect
            title='Especialidade ou transtorno'
            emptyLabel='Nenhuma sugestão encontrada'
            placeholder='Como Ansiedade, Depressão, TDAH'
            showMoreLabel='Mostrar mais resultados...'
          />
          {!shouldHideConsultationValue && (
            <Column width='100%'>
              <Text variant='tiny' textAlign='left' mb='6px' fontWeight='400'>
                Valor da consulta
              </Text>
              <Row alignItems='center'>
                <Text
                  variant='regular'
                  textAlign='left'
                  width='25%'
                  color='darkPrimary'
                  fontWeight='400'
                >
                  {`R$ ${filters?.min_price}`}
                </Text>

                <Row width='100%'>
                  <RangeSlider
                    range
                    min={50}
                    max={350}
                    value={[filters?.min_price, filters?.max_price]}
                    onChange={onChangeConsultationPriceRange}
                    allowCross={false}
                    pushable={9}
                  />
                </Row>

                <Text
                  variant='regular'
                  textAlign='right'
                  width='25%'
                  color='darkPrimary'
                  fontWeight='400'
                >
                  {`R$ ${filters?.max_price}`}
                </Text>
              </Row>
            </Column>
          )}
        </Row>
        <Row id='top-filters' justifyContent='space-between' className='search-buttons'>
          <Filter onClick={onToggleMoreFiltersVisibility}>
            <Text
              ml='10px'
              height='fit-content'
              variant='small'
              color='darkPrimary'
              fontWeight='600'
            >
              Mais filtros
            </Text>
            <FunnelSimple size={22} color='#FF7708' weight='bold' />
          </Filter>
          <Button
            height='51px'
            minWidth='154px'
            fontSize='14px'
            fontWeight='600'
            width='100%'
            borderRadius='10px'
            onClick={onSearchPsychologists}
            disabled={psychologists?.loading}
            data-toggle='collapse'
            data-target='#collapseSearchFilters'
            aria-expanded='false'
            aria-controls='collapseSearchFilters'
            name='button'
            id='search-button'
          >
            Buscar
          </Button>
        </Row>
      </Container>
    </Column>
  )
}

export default TopFilters

const Container = styled(Row)`
  justify-content: space-between;
  gap: 16px;
  min-width: 1120px;
  padding-bottom: 18px;
  @media (max-width: 992px) {
    min-width: 300px;
    flex-direction: column;
    margin: 0 10px;
  }
`
const Filter = styled(Button)`
  background: transparent;
  border: 1px solid #ff7708;
  border-radius: 10px;
  font-size: 14px;
  font-weight: bold;
  height: 51px;
  min-width: 154px;
  width: 100%;
  display: flex;
  gap: 10px;
  margin-right: 18px;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  @media (max-width: 770px) {
    margin-right: 10px;
    padding: 0 0;
  }
  @media (max-width: 320px) {
    margin-right: 5px;
  }
`
